import classnames from 'classnames'
import ConversationHistoryListItem from 'components/ConversationHistoryListItem'
import useConversationHistoryToggle from 'hooks/useConversationHistoryToggle'
import { values } from 'ramda'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { orderConversationsBy } from 'utils/conversation'

import './style.css'

const ConversationHistory = () => {
  const {
    conversationHistoryOpen
  } = useConversationHistoryToggle()

  const conversations = useSelector(state => (
    state.conversations.conversations
  ))

  const conversationsSortedByLastUpdatedDate = useMemo(() => {
    return orderConversationsBy(values(conversations), 'updatedAt') ?? []
  }, [conversations])

  const ConversationHistoryList = useMemo(() => (
    <ul className="drift-widget-conversation-history-list">
      {conversationsSortedByLastUpdatedDate.map(conversation => (
        <ConversationHistoryListItem
          key={conversation.conversation.id}
          conversation={conversation}
        />
      ))}
    </ul>
  ), [conversationsSortedByLastUpdatedDate])

  return (
    <div
      className={classnames("drift-widget-conversation-history", {
        "drift-widget-conversation-history--open": conversationHistoryOpen
      })}
      aria-hidden={!conversationHistoryOpen}
    >
      {conversationHistoryOpen && ConversationHistoryList}
    </div>
  )
}


export default ConversationHistory
